<div class="db-website-item-menu" [ngClass]="{'db-websites_inactive': !website?.isActive && !website?.cloudflareEnabled}">

  <db-env-switcher *ngIf="website?.domain_hash && !website?.isNetwork && !stagingAccessOnly"
                   [websiteId]="website?.id" [currentEnv]="website?.type"
                   [stagingEnabled]="devEnvironmentEnabled" [changingEnv]="changingEnvironment"
                   [websiteSettingLoad]="websiteSettingsLoading"></db-env-switcher>

  <div class="db-website-item-menu__sidebar-subsites-list-title" (click)="toggle()" *ngIf="website?.parentId">
    <div class="db-website-item-menu__sidebar-subsites-header-wrap">
      <span class="db-subsite-header-title" [innerHtml]="parentWebsite?.title"></span>
      <span class="db-website-item-menu__sidebar-subsites-toggle">
      <i class="db-icon db-icon-ds-arrow-small" [ngClass]="{'toggled': subsitesToggled}"></i>
      </span>
    </div>

  </div>
  <div class="db-website-item-menu__sidebar-subsites-list" *ngIf="showSubsiteList"
       [ngClass]="{'toggled': subsitesToggled, 'hosted-subsite': website?.domain_hash && website?.parentId}">
    <div class="db-multisite-back"
         (click)="toggle()"><i class="db-icon db-icon-ds-arrow mr8"></i><span>Back</span></div>
    <div class="db-website-sidebar-dropdown-list-image__content">
      <a class="db-website-item-menu__sidebar-dropdown-list-item db-network-item"
         (click)="gotToSite(website?.parentId)">
        <img src="assets/images/common/multisite_thumbnail.png" alt=""/>
        <span>{{'text_multisite_network' | dbText}}</span>
        <i class="db-icon db-icon-subsite-go-to"></i>
      </a>
      <div *ngIf="networkSubsites?.length" class="db-website-sidebar-dropdown-list-wrap">
        <div class="db-website-sidebar-dropdown-list-image-title">{{"text_site_multisite_network" | dbText}}</div>
        <ul>
          <li *ngFor="let subsite of networkSubsites">
            <a class="db-website-item-menu__sidebar-dropdown-list-item sites" (click)="gotToSite(subsite?.id)">
              <img [src]="subsite?.screenshot ? 'data:image/jpg;base64,' + subsite?.screenshot :
              'assets/images/common/no_screenshot.svg'" alt=""/>
              <span>{{subsite?.site_url}}</span>
              <i class="db-icon db-icon-subsite-go-to"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>


  <div class="db-website-item-menu__main-content" [ngClass]="{'without-hosting': !website?.domain_hash, 'db-multisite':
  website?.isNetwork && !website?.parentId, 'has-password-protection': hasPasswordProtection}">

    <div *ngIf="!website?.isNetwork || (website?.isNetwork && website?.parentId)" class="db-website-item-menu__thumb"
         [ngClass]="{'db-website-item-menu__no-thumb': (!website?.screenshot || website?.isLocalhost),
         'db-password-protection': hasPasswordProtection}"
         [ngStyle]="{backgroundImage: 'url(&quot;'+ (website?.screenshot && !website?.isLocalhost ? 'data:image/jpg;base64,' +
         website?.screenshot : (website?.isAiBuilderDemo ? 'assets/images/common/no_screenshot-demo.png' : null)) + '&quot;)'}"></div>

    <div *ngIf="website?.isNetwork && !website?.parentId"
         class="db-website-item-menu__thumb db-website-item-menu__thumb-multisite">
      <span>Multisite</span>
    </div>

    <div class="db-website-item-menu__actions" *ngIf="website?.isActive"
         [ngClass]="{'db-multisite': website?.isNetwork && !website?.parentId, 'db-password-protection':
         hasPasswordProtection}">

      <ds-score *ngIf="!website?.isNetwork && website?.type === 'live'" (click)="redirectToInner(website?.id)"
                [error]="!websiteScore || (websiteScore === 101 && mobileScore === 101)"
                [loading]="website?.isActive && !!(ongoingGoogleScoreActivity$ | async)"
                [dsTooltip]="(ongoingGoogleScoreActivity$ | async) ? ('text_googleSpinnerDesc' | dbText) :
                !websiteScore || (websiteScore === 101 && mobileScore === 101) ? ('text_googleSpinnerDescError' |
                dbText) :scoreTooltipRef"
                [dsTooltipPosition]="!(ongoingGoogleScoreActivity$ | async) && websiteScore ? 'right' : 'bottom'"
                [dsTooltipAlign]="!(ongoingGoogleScoreActivity$ | async) && websiteScore ? 'bottom' : 'left'"
                [dsTooltipColor]="'white'"
                [dsTooltipSize]="'medium'"
                [score]="websiteScore" [zIndex]="2" position="absolute" [x]="8" [y]="5"></ds-score>

      <div *ngIf="!website?.isNetwork || (website?.isNetwork && website?.parentId)"
           class="db-website-item-menu__action-buttons">
        <div class="db-website-item-menu__action-buttons-wrapper">
          <div class="db-wp-buttons db-tour-step1-origin">
            <a class="db-website-item-menu__action-button sl-website-item-menu_back_url"
               *ngIf="currentSubscription?.trialClient"
               dbWpLink
               [adminLink]="website?.adminUrl" [websiteId]="website?.id" target="_blank" rel="noopener"
               [dsTooltipPosition]="'bottom'"
               [dsTooltipAlign]="'left'"
               [dsTooltipSize]="'medium'"
               [dsTooltipColor]="website?.type === 'live' ? 'black' : 'white'"
               [dsTooltip]="wpTooltip"><i class="db-icon db-icon-ds-wp-link"></i>
            </a>
            <ng-container *ngIf="!currentSubscription?.trialClient">
              <a class="db-website-item-menu__action-button sl-website-item-menu_back_url"
                 *ngIf="website?.connectedFrom !== 'speed_optimizer'"
                 dbWpLink
                 [adminLink]="website?.adminUrl" [websiteId]="website?.id" target="_blank" rel="noopener"
                 [dsTooltipPosition]="'bottom'"
                 [dsTooltipAlign]="'left'"
                 [dsTooltipSize]="'medium'"
                 [dsTooltipColor]="website?.type === 'live' ? 'black' : 'white'"
                 [dsTooltip]="wpTooltip"><i
                class="db-icon db-icon-ds-wp-link"></i>
              </a>
            </ng-container>
          </div>
            @if (this.website?.isWVC && needRedirectToRegenerate){
                <a class="c db-website-item-menu__action-button db-website-item-menu_edit-website"
                   [dsTooltipPosition]="'bottom'"
                   [dsTooltipAlign]="'left'"
                   [dsTooltipSize]="'medium'"
                   [dsTooltipColor]="website?.type === 'live' ? 'black' : 'white'"
                   [dsTooltip]="'text_editDesc' | dbText"
                   (click)="handleEditClick()">
                    <i class="db-icon db-icon-ds-edit-website 1"></i></a>
            }@else{
                <a class="c db-website-item-menu__action-button db-website-item-menu_edit-website"
                   [dsTooltipPosition]="'bottom'"
                   [dsTooltipAlign]="'left'"
                   [dsTooltipSize]="'medium'"
                   [dsTooltipColor]="website?.type === 'live' ? 'black' : 'white'"
                   [dsTooltip]="'text_editDesc' | dbText"
                   dbWpLink
                   [adminLink]="redirectUrl"
                   [websiteId]="website?.id" target="_blank" rel="noopener"
                   (click)="handleEditClick()">
                    <i class="db-icon db-icon-ds-edit-website 1"></i></a>

            }

        </div>
      </div>

      <div *ngIf="website?.isNetwork && !website?.parentId && website?.isActive"
           class="db-website-item-menu__action-buttons">
        <div class="db-website-item-menu__action-buttons-wrapper">
          <a class="db-website-item-menu__action-button sl-website-item-menu_front_url"
             [dsTooltipColor]="website?.type === 'live' ? 'black' : 'white'"
             [dsTooltipPosition]="'bottom'" [dsTooltipAlign]="'right'"
             [dsTooltip]="multisiteTooltip"
             dbWpLink
             [adminLink]="website?.adminUrl"
             [websiteId]="childWebsiteId ? childWebsiteId : website?.id" target="_blank" rel="noopener">
            <i class="db-icon db-icon-ds-sidebar-multisite"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="db-website-item-menu__inactive" *ngIf="!website?.isActive">
      <div class="main-wrap">
        <div class="not-connected-icon-wrap">
          <i class="db-icon db-icon-Inactive-not-connect"></i>
        </div>
        <div class="not-connected-desc" [innerHTML]="'text_websiteInactive' | dbText"></div>
      </div>
    </div>
  </div>

  <div class="db-website-item-menu__info">
    <div class="website-info-wrap">
      <a target="_blank" rel="noopener" class="a db-website-item-menu__site-url  sl-website-item-menu_site_url"
         href="{{previewUrl}}"
         [ngClass]="{'demo-user': !!demoUser}"
         *ngIf="!website?.isAiBuilderDemo && ((!passwordProtectionFirstTimeClickedOverlay || !hasPasswordProtection))">
        <span>{{demoUser ? 'Preview my website' : siteUrl}}</span>
      </a>
      <a class="b db-website-item-menu__site-url  sl-website-item-menu_site_url"
         (click)="showDemoIframe()"
         [ngClass]="{'demo-user': !!demoUser}"
         *ngIf="website?.isAiBuilderDemo && ((!passwordProtectionFirstTimeClickedOverlay || !hasPasswordProtection))">
        <span>{{demoUser ? 'Preview my website' : siteUrl}}</span>
      </a>
    </div>
    <div class="manage-action-wrap">
      <a [routerLink]="['/websites/' + website?.id]" *ngIf="!hideManageButton" class="ds-btn ds-btn-blue">
        <span>{{'text_manageButton' | dbText}}</span></a>
    </div>
    <div class="db-website-item-menu__inactive-info" *ngIf="!website?.isActive && !website?.cloudflareEnabled"></div>
  </div>
</div>

<ng-template #scoreTooltipRef>
  <db-score-info-tooltip-hover [websiteScore]="website?.score" [websiteId]="website?.id"
  ></db-score-info-tooltip-hover>
</ng-template>

<ng-template #wpTooltip>
  <p class="ds-tooltip-title"
     [innerHTML]="'text_wpAdminInfoTitle' | dbText"></p>
  <p [innerHTML]="'text_wpAdminInfoDesc' | dbText"></p>
</ng-template>

<ng-template #multisiteTooltip>
  <p class="ds-tooltip-title"
     [innerHTML]="'text_wpAdminInfoTitleMultisite' | dbText"></p>
  <p [innerHTML]="'text_wpAdminInfoDesc' | dbText"></p>
</ng-template>

